<template lang="pug">
  header.TheHeader.the-header(
    :class="{'hide-toggler': isHideTogglerButton}",
    ref="header",
  )
    .toolbar(
      :class="{'fixed': isFixed, 'hide-shadow': isHideHeaderShadow,}"
    )
      v-container(header-container grid-list-lg)
        v-layout(row wrap align-center)
          .logo
            a.logo-link(
              href="/",
              @click="onLogoClick",
            )
              AcreTraderLogoSvg.acreLogo
          BaseTogglerButton(
            v-show="!isLoginPage && !isSignUpPage"
            @click.native="togglerValue = !togglerValue",
            :value="togglerValue",
          )
            .nitification-on-toggle(
              v-show="notificationsAllNew > 0"
              :class="{'plus': notificationsAllNew > 99, 'is-red': isSomeNotificationsWithRedFlag }"
            )
              .count {{ notificationsAllNew > 99 ? '99+' : notificationsAllNew }}
          .top-bar-left
            TheHeaderMenu.the-header-menu(v-show="isVisibleDesktopMenu" :children="menu.children")
            .vertical-line(v-show="isVisibleDesktopMenu")
            .top-bar-right
              .flex-wrap(v-show="isShowAsLoggedIn")
                p.small-text.welcome-text.mb-0(
                  v-show="isWelcomeText"
                  :class="{'is-skip': isSkipForNow}"
                ) {{ userWelcome }}
                TheHeaderMenuNotifications(v-show="isVisibleDesktopMenu")
                TheHeaderUserMenu(
                  :disabled="!isVisibleDesktopMenu"
                  :class="{'is-social-register': isCompleteSocialRegistration}"
                )
            TheHeaderLoginSignupLogic(
              v-show="!isLoggedIn"
              :is-login-page="isLoginPage",
              :is-sign-up-page="isSignUpPage",
            )
    NavigationDrawerMenu(
      :value="togglerValue"
      @closed-menu="togglerValue = false"
    )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { scrollToElement } from 'Utils/view';
import { HEADER_MENU } from 'Config/menu';
import NavigationDrawerMenu from 'Components/NavigationDrawerMenu/NavigationDrawerMenu';
import BaseTogglerButton from 'Components/Base/BaseTogglerButton';
import AcreTraderLogoSvg from './TheHeaderLogoSvg';
import TheHeaderMenuNotifications from './TheHeaderMenuNotifications';
import TheHeaderMenu from './TheHeaderMenu';
import TheHeaderLoginSignupLogic from './TheHeaderLoginSignupLogic';
import TheHeaderUserMenu from './TheHeaderUserMenu';
import TheHeaderSkipForNow from './TheHeaderSkipForNow';

export default {
  name: 'TheHeader',
  components: {
    TheHeaderMenu,
    TheHeaderMenuNotifications,
    BaseTogglerButton,
    NavigationDrawerMenu,
    AcreTraderLogoSvg,
    TheHeaderLoginSignupLogic,
    TheHeaderUserMenu,
    TheHeaderSkipForNow,
  },
  data() {
    return {
      scrollPosition: 0,
      isFixed: false,
      togglerValue: false,
      sw: false,
      isBanner: false,
    };
  },
  computed: {
    ...mapGetters('login', [
      'isLoggedIn',
      'isFirstLogin',
    ]),
    ...mapGetters('profile', [
      'profileData',
      'individualInvestmentProfile',
    ]),
    ...mapGetters('router', [
      'router',
    ]),
    ...mapGetters('notifications', [
      'notificationsAllNew',
      'isSomeNotificationsWithRedFlag',
    ]),
    ...mapGetters('view', [
      'isOpenMobileMenu',
    ]),
    isSignUpPage() {
      return (this.$route.name || '').startsWith('sign-up') && !this.isCompleteSocialRegistration;
    },
    isLoginPage() {
      return ['sign-in', 'reset-password'].includes(this.$route.name);
    },
    isHideHeaderShadow() {
      return Boolean(this.$route.path.startsWith('/learn') || this.$route.path.startsWith('/resources/farmland-values'));
    },
    isShowAsLoggedIn() {
      return this.isLoggedIn && !this.isLoginPage && !this.isSignUpPage;
    },
    isHideTogglerButton() {
      return Boolean(this.isSkipForNow || this.isCompleteSocialRegistration);
    },
    routerNameUpdating() {
      if (this.router.currentRoute) {
        return this.router.currentRoute.path;
      }
      return true;
    },
    isSkipForNow() {
      return this.$route.name === 'sign-up-accreditation';
    },
    isVisibleDesktopMenu() {
      return Boolean(!this.isSignUpPage && !this.isLoginPage && !this.isSkipForNow && !this.isCompleteSocialRegistration);
    },
    isCompleteSocialRegistration() {
      return (this.$route.name || '').startsWith('sign-up-social');
    },
    userFirstName() {
      const profileData = this.individualInvestmentProfile
        ? this.individualInvestmentProfile.personal
        : this.profileData;
      return profileData.first_name;
    },
    userWelcome() {
      if (this.isFirstLogin) return `Welcome, ${this.userFirstName}!`;
      return `Hello, ${this.userFirstName}!`;
    },
    isWelcomeText() {
      return this.isLoggedIn && !this.isCompleteSocialRegistration && !this.isSkipForNow;
    },
  },
  watch: {
    scrollPosition: {
      handler: 'setIsFixed',
      immediate: true,
    },
    routerNameUpdating() {
      this.togglerValue = false;
    },
    isOpenMobileMenu() {
      this.togglerValue = this.isOpenMobileMenu;
    },
    togglerValue: {
      handler() {
        this.setOpenMobileMenu(this.togglerValue);
      },
      immediate: true,
    },
    isLoggedIn: {
      immediate: true,
      handler(isLoggedIn) {
        if (isLoggedIn) {
          this.getNotificationCounts(true);
        }
      },
    },
  },
  mounted() {
    window.addEventListener('scroll', this.setScrollPosition);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setScrollPosition);
  },
  methods: {
    ...mapActions('notifications', [
      'getNotificationCounts',
    ]),
    ...mapActions('view', [
      'setOpenMobileMenu',
    ]),
    setScrollPosition() {
      this.scrollPosition = window.pageYOffset;
    },
    setIsFixed() {
      this.isFixed = this.scrollPosition > 0;
    },
    onLogoClick() {
      if (this.$route.name === 'home') {
        this.togglerValue = false;
        scrollToElement(this.$refs.header);
      }
    },
  },
  staticData: {
    __prerender: window.__prerender,
    menu: HEADER_MENU,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.header-container
  padding: 0
  position: relative
  @media screen and (max-width: 991px)
    position: static
  .layout
    margin-left: 0!important
    margin-right: 0!important
.vertical-line
  width: 1px
  background-color: #F3F3F3
  height: 39px
  margin-left: 30px
  margin-right: 30px
  @media screen and (max-width: 991px)
    display: none
.the-header
  height: 64px
  .toolbar
    height: 64px
    position: fixed
    width: 100%
    left: 0
    top: 0
    +mt(.1s)
    box-shadow: 0 1px 15px 0 transparent
    border-bottom: 1px solid transparent
    z-index: 10
    display: flex
    align-items: center
    flex-direction: column
    justify-content: center
    @media screen and (max-width: 991px)
      border-bottom: 1px solid #F3F3F3
      background-color: $white
    ::v-deep .v-toolbar__content
      justify-content: center
      padding: 0 !important
      height: 64px !important
    &.fixed
      position: fixed
      width: 100%
      top: 0
      left: 0
      +mt(.1s)
      box-shadow: 0 1px 15px 0 rgba(0, 0, 0, 0.05)
      border-bottom: 1px solid #F3F3F3
      background-color: $white
      z-index: 10
      &.hide-shadow
        box-shadow: 0 1px 15px 0 transparent
  .align-center
    align-items: center
    justify-content: space-between
    @media screen and (max-width: 767px)
      justify-content: space-between
  .logo
    margin-left: 0
    max-width: 180px
    &-link
      display: flex
      flex-direction: column
    .acreLogo
      width: 180px
      @media screen and (max-width: 860px)
        width: 143px
  .mobile-sign
    position: absolute
    right: 15px
    @media screen and (min-width: 768px)
      display: none
  .welcome-text
    margin-right: 35px
    @media screen and (min-width: 992px)
      display: none
    @media screen and (max-width: 360px)
      font-size: 8px
    &.is-skip
      margin-right: 10px
.top-bar-left
  display: flex
  flex-direction: row
  align-items: center
  .menu
    top: -1px
    @media screen and (max-width: 991px)
      display: none
.top-bar-right
  display: flex
  flex-direction: row
  align-items: center
  .flex-wrap
    display: flex
    flex-direction: row
    align-items: center
  a
    line-height: 18px
  .skip-link
    font-size: 14px
    line-height: 20px
    margin-right: 30px
    @media screen and (max-width: 991px)
      margin-right: 0
  .v-btn
    font-size: 14px
.hide-toggler
  ::v-deep .header-toggler
    display: none
::v-deep .header-toggler
  @media screen and (min-width: 992px)
    display: none
  &.is_open
    .nitification-on-toggle
      opacity: 0
      +mt(.3s)
.nitification-on-toggle
  position: absolute
  background-color: $secondary
  top: -7px
  right: -8px
  border-radius: 100px
  border: solid 1px #fff
  z-index: 2
  width: 17px
  height: 17px
  opacity: 1
  +mt(.3s)
  &.plus
    width: 24px
    right: -10px
  &.is-red
    background-color: $support_red
  .count
    font-size: 10px
    font-family: $font-medium
    font-weight: 500
    color: $white
    position: absolute
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
.the-header-menu,
.top-bar-right,
  ::v-deep li
    &:hover
      ul.vertical
        visibility: visible
        opacity: 1
        +mt(.1s)
        li
          z-index: 1
          pointer-events: auto
        @media screen and (max-width: 767px)
          position: relative
          height: 100%
          padding-bottom: 40px
.the-header-menu
  ::v-deep ul.vertical
    left: -5px
    top: 64px
::v-deep ul.vertical:not(.notifi-menu)
  position: absolute
  padding-top: 9px
  padding-bottom: 13px
  cursor: pointer
  overflow: hidden
  visibility: hidden
  background-color: #fff
  opacity: 0
  +mt(.1s)
  box-shadow: 0px 10px 40px -5px rgba(62, 62, 62, 0.1)
  border-radius: 2px
  @media screen and (max-width: 767px)
    position: relative
    height: 0
    top: 0
  li
    @media screen and (min-width: 768px)
      background-color: #fff
      padding: 0
      width: 157px
      margin: 1px 0
      pointer-events: none
      display: flex
      a
        font-size: 14px
        line-height: 20px
        font-weight: 600
        font-family: $font-semibold
        color: $primary
        padding: 7px 20px
        width: 100%
        display: flex
      &:hover
        transition: all 0.3s ease-in-out
        a
          color: #9D9C9C
</style>
